import { Divider } from '@outdoorsyco/bonfire';
import React, { FC, memo } from 'react';

import { TCurrency } from '@/config/locales';
import { formatCurrency } from '@/utility/currency';

interface EarningCredits {
  title: string;
  credits: number;
  currency: TCurrency;
}

interface IEarningStatsProps {
  earningsTitle: string;
  earningCredits: EarningCredits[];
}

const EarningStats: FC<IEarningStatsProps> = ({ earningsTitle, earningCredits = [] }) => {
  return (
    <div className="w-full max-w-full px-12 py-8 border rounded-lg lg:sticky top-8 border-gray-310">
      {earningsTitle && <h4 className=" text-gray-800 h4">{earningsTitle}</h4>}
      <div className="mt-12 mb-4 top">
        {earningCredits.map(({ title, credits, currency }, idx) => (
          <div key={idx} className=" text-gray-700 body-base">
            <div className="flex justify-between">
              {title && <span>{title}</span>}
              {formatCurrency({
                currency: currency || 'USD',
                digits: 2,
                maxDigits: 2,
                priceInCents: credits || 0,
              })}
            </div>

            {idx !== earningCredits.length - 1 && <Divider className="my-4" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(EarningStats);
